import { createAction, props } from '@ngrx/store';

import { Action } from '@models';
import { PageResult } from 'src/app/services/util/query';

// Fetch Actions:
export const fetchActions = createAction('[Action] Fetch Initiated');
export const fetchActionsSuccess = createAction(
  '[Action] Fetch Success',
  props<{ actions: PageResult<Action> }>()
);
export const fetchActionsFailed = createAction(
  '[Action] Fetch Failed',
  props<{ error: Error }>()
);
